import { Padding } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import NoDataImg from "../../assets/images/icons/catering-rewards/nodata-image.svg";
export const NoDataPage = () => {
  return (
    <MDBox
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        padding: "40px",
        height: "100%",
        width: "100%",
      }}
    >
      <img src={NoDataImg} alt="no data image" />
      <MDTypography sx={{ mt: 5, mb: 0, fontSize: "16px" }}>
        Currently we don&apos;t have anything to show here
      </MDTypography>
    </MDBox>
  );
};
